import { render, staticRenderFns } from "./CookieYes.vue?vue&type=template&id=238b4208&scoped=true&"
import script from "./CookieYes.vue?vue&type=script&lang=js&"
export * from "./CookieYes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "238b4208",
  null
  
)

export default component.exports